import React from 'react';

import {CircularProgress} from "@mui/joy";

// components
import BaseApi from "../../utils/BaseApi";
import WebinarCard from "./WebinarCard";
import CommonPaginatedComponentList from "../Common/CommonPaginatedComponentList";
import withRouter from "../../utils/withRouter";
import UserContext from "../../context/UserContext";


class WebinarMy extends React.Component {
    static contextType = UserContext

    constructor(props) {
        super(props);
        this.state = {
            webinars: null,
            pages: null,
            pageNumber: 1
        };
    }

    async componentDidMount() {
        await this.retrieveWebinars();
    }

    async componentDidUpdate(prevProps, prevState, snapshot){
        if (prevProps !== this.props){
            await this.retrieveWebinars();
        }
    }

    async retrieveWebinars(){
        this.setState({
            webinars: null
        });
        const url = 'webinar/my/';
        const params = {
            page: this.props.params.pageNumber!==undefined?parseInt(this.props.params.pageNumber):1,
            ordering: 'start_dt',
        };
        const api = new BaseApi();
        let response = await api.get(
            url,
            params
        );
        await this.setState(
            {
                webinars: response.data.results,
                pages: response.data.total_pages,
            }
        );
    }

    render() {
        if (!this.state.webinars){
            return(
                <CircularProgress/>
            )
        }
        return(
            <CommonPaginatedComponentList
                title={'Мои вебинары'}
                url={'webinar/my'}
                component={WebinarCard}
                componentKeyword={'webinar'}
                data={this.state.webinars}
                pages={this.state.pages}
                pageNumber={this.props.params.pageNumber!==undefined?parseInt(this.props.params.pageNumber):1}
            />
        )
    }
}

export default withRouter(WebinarMy)